//export const ENDPOINT: string = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8080/v1/graphql' : 'https://zimtnow.com/endpoint/v1/graphql';
export const ENDPOINT: string = "https://zimt.app/v1/graphql";
export const STORAGE: string = "https://zimt.app/v1/storage/files/";